// React and routing
import React, { useState, useEffect, useRef, useMemo } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { FiEdit, FiBell, FiCalendar } from "react-icons/fi";

// Styles
import "react-datepicker/dist/react-datepicker.css";
import "./list.css";

// Utilities and configurations
import FastAPIClient from "../../client";
import config from "../../config";

// Internationalization
import { IntlProvider } from "react-intl";
import messages_en from "./translations/en.json";
import messages_fr from "./translations/fr.json";

import { ParentComponent } from "../../components/ParentComponent/ParentComponent";
import Notes from "../../components/Notes/Notes";
import { DocumentsList } from "../../components/DocumentsList/DocumentsList";
// import ClientCard from "../../components/ClientCard";
import ClientForm from "../../components/Client/ClientForm";
import Unauthorized from "../unauthorized/index/index";

// Components

import Loader from "../../components/Loader";

import Meetings from "../../components/Meetings";

import ReportForm from "../../components/LayoutComponents/ReportForm";
import ReminderModal from "../../components/ModalComponents/ReminderModal";

import MeetingModal from "../../components/ModalComponents/MeetingModal";

import CustomIconButton from "../../components/Buttons/CustomIconButton";

import { useOfflineMeetings } from "../../components/OfflineContext";

// Icons
import { FiArrowLeft } from "react-icons/fi";

import {
    CACHE_RESPONSE_API,
    CACHE_RESPONSE_DATA,
} from "../../sw/utils/constants";
import { getDataFromStore } from "../../sw/utils/db";
import { useNetwork } from "../../components/NetworkProvider";
import ClientBottom from "../../components/Client/ClientBottom";
import ClientHeader from "../../components/Client/ClientHeader";

// Initialize client and messages
const client = new FastAPIClient(config);

const messages = {
    en: messages_en,
    fr: messages_fr,
};

const formatModalDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
};

const LeadPage = () => {
    const { clientId } = useParams();
    const [authorized, setAuthorized] = useState(false);
    const [clientInfo, setClientInfo] = useState([]);
    const [meetinghistory, setClientMeetingHistory] = useState([]);

    const [reportlayout, setReportLayout] = useState([]);

    const targetDivRef = useRef(null);
    const [refreshing, setRefreshing] = useState(true);
    const [openmodal, setOpenModal] = useState(false);
    const [locale, setLocale] = useState();
    const [user, setUser] = useState(false);
    // const [shopURL, setUrl] = useState([]);
    const [reportToggle, setReportToggle] = useState(false);
    const [reminderToggle, setReminderToggle] = useState(false);
    const [message, setMessage] = useState(null); // State to store message
    const [usersData, setUsersData] = useState([]);

    const [messageType, setMessageType] = useState(null); // Type of message (success or error)
    const { isOnline } = useNetwork();

    const {
        offlineMeetings,
        offlineReports,
        offlineUpdateMeeting,
        offlineDeleteMeeting,
    } = useOfflineMeetings();

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const meetingId = queryParams.get("meeting_id"); // Extract meeting_id
    const meeting_type_id = queryParams.get("meeting_type_id"); // Extract meeting_id

    const now = new Date();
    const initialStartDate = formatModalDate(now); // Current date and time
    const initialEndDate = formatModalDate(
        new Date(now.getTime() + 30 * 60000)
    ); // Current date and time plus 30 minutes

    const [newEventData, setNewEventData] = useState({
        title: "",
        client_id: clientInfo?.client_id || "",
        start: initialStartDate,
        end: initialEndDate,
        attendees: [],
        is_organizer: true,
    });

    // fetch user data (for meeting)
    const fetchUsersData = async () => {
        const data = await client.getUsers();
        setUsersData(data.results);
    };

    const formatReports = (data) => {
        if (!data?.length) return [];
        return data.map((item) => {
            return {
                user: {
                    user_id: user?.user_id,
                    first_name: user?.first_name,
                    last_name: user?.last_name,
                },
                type: {
                    created_at: null,
                    description: "Visite",
                    meeting_type_id: "1",
                },
                report: item,
                client_id: item.client_id,
                meeting_id: item.meeting_id,
                is_visited: true,
                start_date: item.created_at,
                end_data: item.created_at,
                meeting_type_id: "1",
            };
        });
    };

    const openModal = () => {
        setNewEventData({
            ...newEventData,
            start: initialStartDate,
            end: initialEndDate,
            client: clientInfo,
            user: user,
            client_id: clientInfo.client_id,
            client_name: clientInfo.client_name,
            address_1: clientInfo?.address_1,
            lat: clientInfo?.lat,
            long: clientInfo?.long,
            zip_code: clientInfo?.zip_code,
            city: clientInfo?.city,
            country: clientInfo?.country,
        });
        setOpenModal(true); // This navigates back one step in the history
    };
    const closeModal = () => {
        getClientInfo(user.user_id, clientId);
        setOpenModal(false); // This navigates back one step in the history
    };

    useEffect(() => {
        setLocale(localStorage.getItem("language"));
        const storedLayoutData = localStorage.getItem("layoutData");
        if (storedLayoutData) {
            try {
                const parsedData = JSON.parse(storedLayoutData);
                setUrl(parsedData); // Store the parsed object in state
            } catch (error) {
                console.error(
                    "Error parsing layoutData from localStorage:",
                    error
                );
            }
        }
    }, []);

    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1); // This navigates back one step in the history
    };

    const handleStartVisit = () => {
        setReportToggle(true);
    };

    const handleSaveVisit = () => {
        setReportToggle(false);

        getClientInfo(user.user_id, clientId);
    };

    const handleSetReminder = () => {
        setReminderToggle(true);
    };

    useEffect(() => {
        getUserName();
        fetchUsersData();
    }, []);

    useEffect(() => {
        // Scroll to the start of the target div when 'toggle' changes
        if (reportToggle && targetDivRef.current) {
            setTimeout(() => {
                targetDivRef.current.scrollIntoView({ behavior: "smooth" });
            }, 100); // Adjust the delay as needed a
        }
    }, [reportToggle, targetDivRef]);

    useEffect(() => {
        if (user.user_id && clientId) {
            getClientInfo(user.user_id, clientId);

            getReportLayout();

            targetDivRef.current = document.getElementById("yourTargetDivId");
        }
    }, [user, clientId, isOnline]);

    const getUserName = () => {
        client.fetchUser().then((data) => {
            setUser(data);
        });
    };

    const getAllOfflineClients = () => {
        const storeName =
            CACHE_RESPONSE_DATA[CACHE_RESPONSE_API.CLIENTS].storeName;
        const url = `${config.apiBasePath}${CACHE_RESPONSE_API.CLIENTS}?user_id=${user.user_id}`;
        getDataFromStore(storeName, url)
            .then((result) => {
                if (result?.data?.length) {
                    const currentClients = result?.data?.filter(
                        (item) => item.client_id === clientId
                    );
                    handleClientDetailInfo(currentClients);
                }
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    };

    const getClientInfo = (userId, clientId) => {
        if (isOnline) {
            client
                .getUserClients(userId, clientId)
                .then((data) => {
                    handleClientDetailInfo(data);
                })
                .catch((error) => {
                    console.error("Error fetching client data:", error);
                    // Check if it's an authorization error (403)
                    if (error.response && error.response.status === 403) {
                        setAuthorized(false);
                        setRefreshing(false);
                        return;
                    }
                    // Handle other errors as before
                    setRefreshing(false);
                });
        } else {
            getAllOfflineClients();
        }
    };

    const handleClientDetailInfo = (data) => {
        if (data && data.length > 0) {
            setClientInfo(data[0]);
            setClientMeetingHistory(data[0].meetings);
            setRefreshing(false);
            setAuthorized(true);
        } else {
            setAuthorized(false);
            setRefreshing(false);
        }
    };

    const getReportLayout = () => {
        client.getReportLayout().then((data) => {
            setReportLayout(data);
        });
    };

    const [successMessage, setSuccessMessage] = useState(""); // Track success message
    useEffect(() => {
        if (successMessage) {
            const timer = setTimeout(() => setSuccessMessage(""), 3000); // Hide message after 3 seconds
            return () => clearTimeout(timer); // Cleanup on unmount
        }
    }, [successMessage]);

    const [errorMessage, setErrorMessage] = useState(""); // Track success message
    useEffect(() => {
        if (errorMessage) {
            const timer = setTimeout(() => setErrorMessage(""), 3000); // Hide message after 3 seconds
            return () => clearTimeout(timer); // Cleanup on unmount
        }
    }, [errorMessage]);

    const totalMeetings = useMemo(() => {
        if (
            (offlineMeetings.length ||
                offlineReports.length ||
                offlineUpdateMeeting.length ||
                offlineDeleteMeeting.length) &&
            clientId &&
            user?.user_id
        ) {
            let currentClientsMeetings = offlineMeetings.filter(
                (item) => item?.client_id === clientId
            );
            let recurrentClientsReports = offlineReports.filter(
                (item) => item?.client_id === clientId
            );
            const formatList = formatReports(recurrentClientsReports);

            let allMeetings = meetinghistory.concat(
                currentClientsMeetings,
                formatList
            );

            if (offlineUpdateMeeting.length) {
                allMeetings = allMeetings.map((meeting) => {
                    const updatedMeeting = offlineUpdateMeeting.find(
                        (updatedMeeting) =>
                            updatedMeeting.meeting_id === meeting.meeting_id &&
                            updatedMeeting.client?.client_id ===
                                meeting.client_id
                    );
                    if (updatedMeeting) {
                        return { ...meeting, ...updatedMeeting };
                    }
                    return meeting;
                });
            }

            if (offlineDeleteMeeting.length) {
                allMeetings = allMeetings.filter(
                    (meeting) =>
                        !offlineDeleteMeeting.includes(meeting.meeting_id)
                );
            }

            return allMeetings.sort(
                (a, b) => new Date(a.start_date) - new Date(b.start_date)
            );
        }

        return meetinghistory;
    }, [
        offlineMeetings,
        meetinghistory,
        offlineReports,
        offlineUpdateMeeting,
        offlineDeleteMeeting, // Make sure this is part of the dependencies!
        clientId,
        user,
    ]);

    const tabs_md = [
        {
            value: "meetings",
            label: "Interactions",
            content: (
                <Meetings visithistory={totalMeetings} openModal={openModal} />
            ),
        },
        {
            value: "notes",
            label: "Notes",
            content: (
                <Notes clientId={clientInfo.client_id} userId={user.user_id} />
            ),
        },
        {
            value: "documents",
            label: "Documents",
            content: <DocumentsList clientId={clientInfo.client_id} />,
        },
    ];

    const tabs = [
        {
            value: "meetings",
            label: "Interactions",
            content: (
                <Meetings visithistory={totalMeetings} openModal={openModal} />
            ),
        },
        {
            value: "notes",
            label: "Notes",
            content: (
                <Notes clientId={clientInfo.client_id} userId={user.user_id} />
            ),
        },
        {
            value: "documents",
            label: "Docs",
            content: <DocumentsList clientId={clientInfo.client_id} />,
        },
        {
            value: "products",
            label: "Produits",
            content: <ClientForm client_id={clientInfo.client_id} />,
        },
        {
            value: "about",
            label: "Détails",
            content: (
                <ClientBottom
                    client_id={clientInfo.client_id}
                    client_name_full={clientInfo.client_name_full}
                    address_1={clientInfo.address_1}
                    phone={clientInfo.phone}
                    mail={clientInfo.mail}
                    website_url={clientInfo.website_url}
                    menu_url={clientInfo.menu_url}
                    client_level_1={clientInfo.client_level_1}
                    zip_code={clientInfo.zip_code}
                    city={clientInfo.city}
                    interior_settings={clientInfo.interior_settings}
                    has_terrace={clientInfo.has_terrace}
                    terrace_settings={clientInfo.terrace_settings}
                    business_hours={clientInfo.business_hours}
                    is_seasonal={clientInfo.is_seasonal}
                    season_start={clientInfo.season_start}
                    season_end={clientInfo.season_end}
                    purchasing_manager={clientInfo.purchasing_manager}
                />
            ),
        },
    ];

    if (refreshing) {
        return <Loader />; // Display Loader while data is being fetched
    }

    if (!authorized) {
        return <Unauthorized />;
    }

    return (
        <section className="flex flex-row md:h-full h-[100%]">
            <div
                style={{
                    flex: 1,
                    overflowY: "auto",
                }}
            >
                <IntlProvider locale={locale} messages={messages[locale]}>
                    <div className="flex justify-start ml-3 md:ml-10 md:mt-4 hidden md:flex">
                        <CustomIconButton
                            onClick={handleGoBack}
                            icon={<FiArrowLeft className="text-2xl" />}
                            sx={{
                                backgroundColor: "#F0F0F0",
                                fontSize: "18px",
                            }}
                        />
                    </div>

                    <div className="pb-4 pl-4 pr-4 flex flex-col block md:hidden">
                        <div className="mb-4 sticky top-0 bg-white z-20">
                            <div className="flex justify-start mb-4 md:ml-10 mt-4 block md:hidden">
                                <CustomIconButton
                                    onClick={handleGoBack}
                                    icon={<FiArrowLeft className="text-2xl" />}
                                    sx={{
                                        backgroundColor: "#F0F0F0",
                                        fontSize: "18px",
                                    }}
                                />
                            </div>
                            <ClientHeader
                                client_name={clientInfo.client_name}
                                client_id={clientInfo.client_id}
                                city={clientInfo.city}
                                totalValue={0}
                                leadStage="Compte créé"
                                percentageFilled={5}
                                onStartVisit={handleStartVisit}
                                onSetReminder={handleSetReminder}
                                onOpenModal={openModal}
                            />
                        </div>
                        <ParentComponent tabs={tabs} />
                    </div>

                    <div className="ml-10 mt-4 hidden md:block">
                        <ClientHeader
                            client_name={clientInfo.client_name}
                            client_id={clientInfo.client_id}
                            city={clientInfo.city}
                            totalValue={0}
                            leadStage="Compte créé"
                            percentageFilled={5}
                            onStartVisit={handleStartVisit}
                            onSetReminder={handleSetReminder}
                            onOpenModal={openModal}
                        />
                    </div>

                    <div className="flex flex-row md:flex w-full xl:px-10 mt-4 gap-4 hidden md:block">
                        {/** Common class for all columns except width */}
                        {[
                            {
                                width: "md:w-1/4",
                                content: (
                                    <ClientBottom
                                        client_id={clientInfo.client_id}
                                        client_name_full={
                                            clientInfo.client_name_full
                                        }
                                        address_1={clientInfo.address_1}
                                        phone={clientInfo.phone}
                                        mail={clientInfo.mail}
                                        website_url={clientInfo.website_url}
                                        menu_url={clientInfo.menu_url}
                                        client_level_1={
                                            clientInfo.client_level_1
                                        }
                                        zip_code={clientInfo.zip_code}
                                        city={clientInfo.city}
                                        interior_settings={
                                            clientInfo.interior_settings
                                        }
                                        has_terrace={clientInfo.has_terrace}
                                        terrace_settings={
                                            clientInfo.terrace_settings
                                        }
                                        business_hours={
                                            clientInfo.business_hours
                                        }
                                        is_seasonal={clientInfo.is_seasonal}
                                        season_start={clientInfo.season_start}
                                        season_end={clientInfo.season_end}
                                        cuisine={clientInfo.cuisine}
                                        purchasing_manager={
                                            clientInfo.purchasing_manager
                                        }
                                    />
                                ),
                            },
                            {
                                width: "md:w-1/2",
                                content: <ParentComponent tabs={tabs_md} />,
                            },
                            {
                                width: "md:w-1/4",
                                content: (
                                    <ClientForm
                                        client_id={clientInfo.client_id}
                                    />
                                ),
                            },
                        ].map((col, index) => (
                            <div
                                key={index}
                                className={`flex flex-col ${col.width} rounded-xl border border-gray-200 p-4`}
                            >
                                {col.content}
                            </div>
                        ))}
                    </div>

                    {message && (
                        <div
                            className={`fixed bottom-10 left-1/2 transform -translate-x-1/2 p-4 rounded-md text-white ${
                                messageType === "success"
                                    ? "bg-green-500"
                                    : "bg-red-500"
                            }`}
                            style={{ zIndex: 999 }}
                        >
                            {message}
                        </div>
                    )}

                    {!reportToggle && !reminderToggle && (
                        <div className="fixed bottom-0 left-1/2 transform -translate-x-1/2 md:left-auto md:right-5 md:transform-none flex w-full justify-end items-center pb-2 md:pb-3 hidden md:flex">
                            <div className="flex flex-col items-center mx-2">
                                <CustomIconButton
                                    onClick={openModal}
                                    icon={
                                        <FiCalendar
                                            style={{ fontSize: "24px" }}
                                            className="text-gold"
                                        />
                                    }
                                    sx={{
                                        backgroundColor: "#000000",
                                        fontSize: "18px",
                                    }}
                                />
                            </div>

                            <div className="flex flex-col items-center mx-2">
                                <CustomIconButton
                                    onClick={handleStartVisit}
                                    icon={
                                        <FiEdit
                                            style={{ fontSize: "24px" }}
                                            className="text-gold"
                                        />
                                    }
                                    sx={{
                                        backgroundColor: "#000000",
                                        fontSize: "18px",
                                    }}
                                />
                            </div>

                            <div className="flex flex-col items-center mx-2">
                                <CustomIconButton
                                    onClick={handleSetReminder}
                                    icon={
                                        <FiBell
                                            style={{ fontSize: "24px" }}
                                            className="text-gold"
                                        />
                                    }
                                    sx={{
                                        backgroundColor: "#000000",
                                        fontSize: "18px",
                                    }}
                                />
                            </div>
                        </div>
                    )}
                    <div id="yourTargetDivId"></div>
                    {reportToggle && (
                        <section className="w-full bg-white flex flex-col items-center border-t border-gray-100  mt-5">
                            {reportlayout.length > 0 && (
                                <ReportForm
                                    reportlayout={reportlayout}
                                    setToggle={handleSaveVisit}
                                    clientId={clientId}
                                    meetingId={meetingId}
                                    userId={user.user_id}
                                    userName={user.first_name}
                                    meeting_type_id={meeting_type_id}
                                    setErrorMessage={setMessage} // Success message in French
                                    setErrorMessageType={setMessageType}
                                />
                            )}
                        </section>
                    )}
                    {reminderToggle && (
                        <section className="w-full bg-white flex flex-col items-center border-t border-gray-100  mt-5">
                            <ReminderModal
                                setReminderToggle={setReminderToggle}
                                userId={user.user_id}
                                clientId={clientId}
                                locale={locale}
                            />
                        </section>
                    )}
                    {openmodal && (
                        <section className="w-full bg-white flex flex-col items-center border-t border-gray-100  mt-5">
                            <MeetingModal
                                closeModal={closeModal}
                                locale={locale}
                                user_id={user.user_id}
                                initialEventData={newEventData}
                                detailsTrue={false}
                                user={user}
                                setSuccessMessage={setSuccessMessage}
                                setErrorMessage={setErrorMessage}
                                is_client_meeting={true}
                                attendees={usersData}
                            />
                        </section>
                    )}
                    {successMessage && (
                        <div className="fixed bottom-0 left-0 right-0 bg-green-500 text-white text-center py-2 z-50 mx-auto w-1/5 rounded-t-lg">
                            {successMessage}
                        </div>
                    )}
                    {errorMessage && (
                        <div className="fixed bottom-0 left-0 right-0 bg-rose-500 text-white text-center py-2 z-50 mx-auto w-1/5 rounded-t-lg">
                            {errorMessage}
                        </div>
                    )}
                </IntlProvider>
            </div>
        </section>
    );
};

export default LeadPage;
